import { Box } from "@mui/system";
import { chatListData } from "./chat-data";
import { FC, useEffect, useState } from "react";
import { H3 } from "../../../components/Typography";
import muiIcons from "../../../components/icons/mui-icons";
import { Avatar, useMediaQuery, useTheme } from "@mui/material";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import IncomingMessage from "../../../components/chat/IncomingMessage";
import ReplayMessage from "../../../components/chat/ReplayMessage";
import { GullButton } from "../../../components/buttons/GullButton";
import UserChatList from "../../../components/chat/UserChatList";
import {
  ChatContainer,
  ChatHeader,
  ChatListBox,
  ChatInboxContainer,
  ChatBody,
  StyledIconButton,
  ChatInput,
  ChatListDrawer,
  ChatInboxFooter,
} from "./chat.style";

const Chat: FC = () => {
  const { MenuIcon, Sent2Icon, FormIcon } = muiIcons;
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredChat, setFilteredChat] = useState(chatListData);

  useEffect(() => {
    if (searchValue.length > 0) {
      const searchResult = chatListData.filter((item) =>
        item.name.toLocaleLowerCase().match(searchValue.toLowerCase())
      );
      setFilteredChat(searchResult);
    } else {
      setFilteredChat(chatListData);
    }
  }, [searchValue]);

  const [singeChat, setSingleChat] = useState<any>(chatListData[0]);
  const findUserChat = (id: number) => {
    const chat = chatListData.find((data) => data.id === id);
    setSingleChat(chat);
  };

  const replayMessage = {
    name: "Smith Doe",
    status: "active",
    message: "Lorem ipsum dolor sit amet.",
    photoUrl: "/assets/images/faces/1.jpg",
  };

  const [chatListDrawer, setChatListDrawer] = useState<boolean>(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  useEffect(() => {
    if (matches) {
      setChatListDrawer(false);
    }
  }, [matches]);

  return (
    <>
      <Breadcrumb name="Apps" subName="Chat" path="/dashboard/v1" />

      <ChatContainer>
        <ChatListBox>
          <UserChatList
            filteredChat={filteredChat}
            setSearchValue={setSearchValue}
            findUserChat={findUserChat}
          />
        </ChatListBox>

        <ChatInboxContainer>
          <Box height="calc(100% - 190px)" position="relative">
            <ChatHeader display="flex" alignItems="center">
              <Box display="flex" alignItems="center">
                <StyledIconButton
                  onClick={() =>
                    chatListDrawer
                      ? setChatListDrawer(false)
                      : setChatListDrawer(true)
                  }
                >
                  <MenuIcon />
                </StyledIconButton>
                <Avatar
                  src={singeChat.photoUrl}
                  sx={{ mr: "10px", width: 35, height: 35 }}
                />
              </Box>
              <H3>{singeChat.name}</H3>
            </ChatHeader>
            <ChatListDrawer variant="persistent" open={chatListDrawer}>
              <UserChatList
                filteredChat={filteredChat}
                setSearchValue={setSearchValue}
                findUserChat={findUserChat}
              />
            </ChatListDrawer>
            <ChatBody>
              <IncomingMessage chatData={singeChat} />
              <ReplayMessage chatData={replayMessage} />
              <IncomingMessage chatData={singeChat} />
              <ReplayMessage chatData={replayMessage} />
              <ReplayMessage chatData={replayMessage} />
              <ReplayMessage chatData={replayMessage} />
              <ReplayMessage chatData={replayMessage} />
            </ChatBody>
          </Box>
          <ChatInboxFooter>
            <ChatInput placeholder="Type your message" rows={3} />
            <Box textAlign="right">
              <GullButton
                rounded={true}
                variant="contained"
                color="primary"
                sx={{ py: "10px" }}
              >
                <Sent2Icon sx={{ fontSize: 14 }} />
              </GullButton>
              <GullButton
                rounded={true}
                variant="outlined"
                color="primary"
                sx={{ py: "10px" }}
              >
                <FormIcon sx={{ fontSize: 14 }} />
              </GullButton>
            </Box>
          </ChatInboxFooter>
        </ChatInboxContainer>
      </ChatContainer>
    </>
  );
};

export default Chat;
